// @flow

import React, { Component } from "react";
import Script from "react-load-script";
import GridLayout from "../../components/GridLayout/GridLayout";
import Page from "../../components/Page/Page";

type State = {
  loading: boolean,
};

class Map extends Component<{}, State> {
  static defaultProps: {};

  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }

  handleScriptLoad = () => {
    this.setState({ loading: false });
    const google = window.google;
    var hq = { lat: 34.090142, lng: -117.881155 };
    var map = new google.maps.Map(document.getElementById("map"), {
      zoom: 10,
      center: hq,
    });
    var infowindow = new google.maps.InfoWindow({
      content:
        "<div><strong>Ought Inc.</strong><br/>440 N Barranca Ave #4405<br />Covina<br />CA 91723</div>",
    });
    var marker = new google.maps.Marker({
      position: hq,
      map: map,
    });
    marker.addListener("click", function () {
      infowindow.open(map, marker);
    });
  };

  render() {
    return (
      <div>
        <Script
          url="https://maps.googleapis.com/maps/api/js?key=AIzaSyADnkfCoP9dVRhud3qDwObsduARDhoc6fM"
          onLoad={this.handleScriptLoad}
        />
        {this.state.loading ? <span>Loading...</span> : null}
        <div id="map" style={{ width: "100%", height: "300px" }} />
      </div>
    );
  }
}

const About = () => {
  return (
    <Page
      className="About"
      title="About us"
      next={{
        url: "/careers",
        title: "Careers",
        description: "See currently open positions and join our team",
      }}
    >
      <GridLayout>
        <h2 id="company">Company</h2>
        <p>
          We're a 501(c)(3) non-profit registered in Delaware and operating in
          California.
        </p>
        <h2 id="location">Location</h2>
        <p>
          Our mailing address is{" "}
          <a href="https://goo.gl/maps/2wiTuQKz3ZztRQSs9">
            440 N Barranca Ave #4405 Covina, CA 91723
          </a>
          .
        </p>
        <Map />

        <h2>Contact us</h2>
        <p>
          You can contact us by email at{" "}
          <a href="mailto:team@ought.org">team@ought.org</a>.
        </p>

        <h2 id="credits">Image credits</h2>
        <ul>
          <li>
            <a href="https://feathericons.com/">Feather icons</a> (
            <a href="https://github.com/colebemis/feather/blob/master/LICENSE">
              MIT license
            </a>
            )
          </li>
          <li>
            <a href="https://phosphoricons.com/">Phosphor icons</a> (
            <a href="https://github.com/phosphor-icons/homepage/blob/master/LICENSE">
              MIT license
            </a>
            )
          </li>
        </ul>
      </GridLayout>
    </Page>
  );
};

export default About;
